function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie-player';
import { Button, Modal } from '@domain-group/fe-co-allhomes-design-system';
import CreatePropertyAlert from '@domain-group/fe-co-allhomes-property-alert-common';
import propertyAlertWrapper from './wrapper';
import Done from '../../../static/done.json';
import * as styles from './action-popup.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class ActionPopup extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "closePopup", evt => {
      if (this.containerRef && !this.containerRef.contains(evt.target)) {
        this.props.onClose();
      }
    });
    _defineProperty(this, "createPropertyAlert", frequency => {
      this.props.createPropertyAlert(frequency.selectedOption);
    });
    _defineProperty(this, "editPropertyAlert", () => {
      this.props.editPropertyAlert();
    });
    _defineProperty(this, "managePropertyAlerts", () => {
      this.props.managePropertyAlerts();
    });
    _defineProperty(this, "removePropertyAlert", () => {
      this.props.removePropertyAlert();
    });
    _defineProperty(this, "displayContent", () => {
      if (!this.props.searchQuery) {
        return this.displayNoLocation();
      }
      if (this.props.showCreateConfirmation) {
        return this.displayConfirm();
      }
      if (this.props.alertId) {
        return this.displayUpdateMenu();
      }
      return this.displayCreateMenu();
    });
    _defineProperty(this, "displayNoLocation", () => ___EmotionJSX("div", {
      css: styles.confirmContent
    }, ___EmotionJSX("div", {
      css: styles.noLocationMessage
    }, "Please first enter a location to create the property alert.")));
    _defineProperty(this, "displayConfirm", () => ___EmotionJSX("div", {
      css: styles.confirmContent
    }, ___EmotionJSX("span", {
      css: styles.tickIconWrapper
    }, ___EmotionJSX(Lottie, {
      loop: false,
      animationData: Done,
      play: true,
      style: {
        width: 36,
        height: 36
      }
    })), ___EmotionJSX("span", {
      css: styles.confirmHeading
    }, "Done"), ___EmotionJSX("div", {
      css: styles.confirmMessage
    }, "We'll let you know when new properties are listed that match your search.")));
    _defineProperty(this, "displayUpdateMenu", () => ___EmotionJSX("div", {
      css: styles.menuContent
    }, ___EmotionJSX("div", {
      css: styles.menuTitle
    }, this.props.alertName), ___EmotionJSX("div", {
      css: styles.menuSubTitle
    }, this.props.filterSummary), ___EmotionJSX("div", {
      css: styles.divider
    }), ___EmotionJSX("div", {
      css: styles.menuButtonWrapper
    }, ___EmotionJSX(Button, {
      css: styles.menuButton,
      appearance: "ghost",
      onClick: this.editPropertyAlert
    }, "Edit this alert"), ___EmotionJSX(Button, {
      css: styles.menuButton,
      appearance: "ghost",
      onClick: this.managePropertyAlerts
    }, "Manage my alerts"), ___EmotionJSX(Button, {
      css: styles.menuButton,
      appearance: "ghost",
      onClick: this.removePropertyAlert
    }, "Remove this alert"), ___EmotionJSX(Button, {
      css: styles.menuButton,
      appearance: "ghost",
      onClick: this.props.onClose
    }, "Cancel"))));
    _defineProperty(this, "displayCreateMenu", () => ___EmotionJSX(CreatePropertyAlert, {
      selectedOption: "Instantly",
      onCancel: this.props.onClose,
      onCreateAlert: this.createPropertyAlert,
      message: this.props.message,
      createButtonLabel: this.props.createButtonLabel,
      css: styles.popupStyle
    }));
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', this.closePopup, false);
    }
  }
  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('mousedown', this.closePopup, false);
    }
  }
  render() {
    var mobile = this.props.media.mobile;
    return mobile ? ___EmotionJSX(Modal, {
      show: true,
      mobileStyle: "auto",
      showHeader: false,
      onClose: this.props.onClose
    }, this.displayContent()) : ___EmotionJSX("div", {
      css: styles.actionPopup,
      ref: containerRef => {
        this.containerRef = containerRef;
      }
    }, this.displayContent());
  }
}
ActionPopup.propTypes = {
  onClose: PropTypes.func,
  alertId: PropTypes.number,
  alertName: PropTypes.string,
  filterSummary: PropTypes.string,
  createPropertyAlert: PropTypes.func.isRequired,
  editPropertyAlert: PropTypes.func.isRequired,
  managePropertyAlerts: PropTypes.func.isRequired,
  removePropertyAlert: PropTypes.func.isRequired,
  showCreateConfirmation: PropTypes.bool,
  media: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  searchQuery: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  message: PropTypes.string,
  createButtonLabel: PropTypes.string
};
ActionPopup.defaultProps = {
  onClose: () => {},
  alertId: null,
  alertName: '',
  filterSummary: '',
  showCreateConfirmation: false,
  media: {},
  searchQuery: null,
  message: 'How often would you like us to send them?',
  createButtonLabel: 'Create alert'
};
export default propertyAlertWrapper(ActionPopup);
export { ActionPopup as BaseActionPopup };